<!--
 * @Descripttion:
 * @version:
 * @Author: June
 * @Date: 2023-05-20 09:18:28
 * @LastEditors: 秦少卫
 * @LastEditTime: 2024-10-06 09:52:13
-->
<template>
  <Dropdown @on-click="setLang" placement="bottom-end">
    <Button type="text">
      {{ lang }}
      <Icon type="ios-arrow-down"></Icon>
    </Button>
    <template #list>
      <DropdownMenu>
        <DropdownItem v-for="lang in langList" :key="lang.langType" :name="lang.langType">
          {{ lang.langName }}
        </DropdownItem>
      </DropdownMenu>
    </template>
  </Dropdown>
</template>

<script setup name="saveBar">
import { setLocal } from '@/utils/local';
import { LANG, LANGMAP, langList } from '@/language/index';
import { useRouter, useRoute } from 'vue-router';
const router = useRouter();
const route = useRoute();
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();

const lang = computed(() => {
  return LANGMAP[locale.value];
});

// 设置语言
const setLang = (type) => {
  locale.value = type;
  setLocal(LANG, type);
  router.replace({
    query: {
      ...route.query,
      lang: type,
    },
  });
};
</script>

<style scoped lang="less"></style>
